import { render, staticRenderFns } from "./stat-pelanggan-masuk.vue?vue&type=template&id=1991fa40&"
import script from "./stat-pelanggan-masuk.vue?vue&type=script&lang=js&"
export * from "./stat-pelanggan-masuk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports